/* eslint-disable react-hooks/exhaustive-deps */
import { urlAuthSSOLogin } from 'constants/urls';
import { parseCronExpression, TimerBasedCronScheduler as scheduler } from 'cron-schedule';
import useUsuario from 'hooks/useUsuario';
import moment from 'moment';
import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { dataUsuario } from 'redux/actions/aLogin';
import { dataUsuarioVacio } from '../../constants';

const CronLogin = () => {
  const { cliCodigoCore, userIsLoggedIn } = useUsuario();
  const dispatch = useDispatch();
  let mouseMove = 0;
  const cron = useMemo(() => parseCronExpression('*/1 * * * *'), []);
  const cron2 = useMemo(() => parseCronExpression('*/1 * * * *'), []);

  const handleMouseMove = (event) => {
    mouseMove = 0;
  };

  const comprobarExpiracionToken = () => {
    const { datosUsuarios } = JSON.parse(localStorage.getItem('state'));
    const exp = datosUsuarios?.dataUsuario?.jwtDecoded?.exp;
    if (exp) {
      if (moment().unix() * 1000 >= (exp - 300) * 1000) {
        localStorage.setItem('login', false);
        dispatch(dataUsuario(dataUsuarioVacio));
        window.location.href = urlAuthSSOLogin;
      }
    }
  };
  useEffect(() => {
    comprobarExpiracionToken();
    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('keydown', handleMouseMove);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('keydown', handleMouseMove);
    };
  }, []);
  useEffect(() => {
    const tarea = scheduler.setInterval(cron, async () => {
      try {
        mouseMove++;
        if (mouseMove > 30) {
          localStorage.setItem('login', false);
          dispatch(dataUsuario(dataUsuarioVacio));
          window.location.href = urlAuthSSOLogin;
        }
      } catch (error) {}
    });
    const tarea2 = scheduler.setInterval(cron2, async () => {
      try {
        comprobarExpiracionToken();
      } catch (error) {}
    });
    return () => {
      scheduler.clearTimeoutOrInterval(tarea);
      scheduler.clearTimeoutOrInterval(tarea2);
    };
  }, [cliCodigoCore, userIsLoggedIn]);
  return true;
};
export default CronLogin;
